import styled from 'styled-components'

import { Title } from 'components/IndexLayout'
import { breakpoint } from 'utils'

export const BreadcrumbsWrapper = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;
    
    text-align: center;
    margin-top: 16px;
  
    + ${Title} {
      margin-top: 32px;
    }
  `}
`
